// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2salr","legacyBtn":"MutateMid_legacyBtn__2kItK"};